module.exports = __webpack_public_path__ + "img/Frame-27.29a96b04.svg";